import React, { useEffect, useState } from 'react';

/**
 * HupalupaAnasayfaAkis: HUPALUPA Store'da ana sayfadan hangi kategorilere
 * akıldığının şeması. Route: /r/hupalupa-anasayfa-akis
 * (ProtectedRoute allowBrandIds, sidebar YOK — doğrudan URL ile açılır.)
 *
 * İçerik statik — API çağrısı yok. Veri GA4 Data API'den (property 364875770)
 * `pageReferrer` × `itemCategory` hiyerarşisi olarak çekilip HTML'e gömüldü.
 * Yeniden üretmek için: node src/pages/hupalupa-anasayfa-akis/build.js
 *
 * 🔑 Raporun çekirdek sınırı: sitede `page_view` olayı yok, o yüzden
 * "ana sayfadan kategori sayfasına tıklandı mı" ölçülemiyor. Ölçülen şey
 * ana sayfadan çıkıp hangi kategorinin ÜRÜNÜNE gidildiği. Sayfadaki sarı
 * uyarı kutusu bunu anlatıyor — kaldırma.
 *
 * Rapor iframe içinde çalışır: kendi CSS'i `:root`, `body`, `h1`, `table` gibi
 * global seçiciler taşıyor; srcDoc izolasyonu dashboard'un stilini korur.
 */
export default function HupalupaAnasayfaAkis() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./hupalupaAnasayfaAkisHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini raporun kendi --ground'u (#F0F1F6) — açılışta beyaz flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F1F6' }} />;

  return (
    <iframe
      title="HUPALUPA Store · Ana Sayfadan Kategoriye Akış"
      srcDoc={html}
      style={fill}
    />
  );
}
